'use strict';

import React from 'react';

class LibraryDescription extends React.Component {

	// Render
	render() {
		return (
			<div className="library-description">
				<h2>Included With Every Subscription</h2>

				<h3>Search for Syndromes</h3>
				<ul>
					<li>Easy access to detailed syndrome descriptions</li>
					<li>Review features most relevant for each syndrome</li>
					<li>Over 10,000 syndromes with detailed references</li>
				</ul>

				<h3>Review Photos & Features</h3>
				<ul>
					<li>Access detailed feature photos and descriptions</li>
					<li>Review syndromes most relevant to each feature</li>
					<li>Over 20,000 feature photos</li>
				</ul>

				<h3>Up-to-date Content Through Genetics Community Curation</h3>
				<ul>
					<li>Updated by respected members of the genetics community</li>
					<li>Easily contribute relevant updates</li>
					<li>Integrated with the Face2Gene community</li>
				</ul>
			</div>
		);
	}
}

export default LibraryDescription;


// WEBPACK FOOTER //
// ./auth/components/Description/Library.jsx